<template>
  <div ref="notificationModal" id="notificationModal" class="modal modal-v modal-v--normal fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body" v-if="notification.type==='App\\Notifications\\Admin\\SendUserInformation'">
          <div v-if="notification.data" class="d-flex flex-column align-items-center justify-content-start justify-content-md-center text-center">
            <div v-if="notification.data.category === 'info'"><img class="profile-show__modal-image" src="../../../images/modals/admin_info.svg" alt="alert-icon"></div>
            <div v-if="notification.data.category === 'warning'"><img class="profile-show__modal-image" src="../../../images/modals/admin_warning.svg" alt="coins-icon"></div>
            <h2 class="title title--large mt-4">
              {{ notification.data.title || trans.get('profile:modal.admin_message') }}
            </h2>
            <p class="desc desc--medium desc--black my-3"> " {{ notification.data.message }} " </p>
          </div>
        </div>
        <div class="modal-body" v-else-if="isBaseModal || isPopupModal">
          <div class="d-flex flex-column align-items-center justify-content-start justify-content-md-center text-center">
            <div v-if="notification.data.picture">
              <img class="profile-show__modal-image mt-3" :src="notification.data.picture" alt="alert-icon">
            </div>

            <div v-if="notification.data.picture_url">
              <img class="profile-show__modal-image mt-3" :src="notification.data.picture_url" alt="alert-icon">
            </div>

            <h2 v-if="notification.data.header" class="title">
              {{ notification.data.header }}
            </h2>

            <p v-if="notification.data.slogan" class="title">
              {{ notification.data.slogan }}
            </p>

            <p v-if="notification.data.top_text" class="desc">
              {{ notification.data.top_text }}
            </p>

            <p v-if="notification.data.bottom_text" class="desc desc--lightgrey mt-2">
              {{ notification.data.bottom_text }}
            </p>

            <div v-if="isBaseModal && notification.data.button_text">
              <a
                v-if="notification.data.button_web_link"
                @click="close"
                class="button button--primary"
                :href="notification.data.button_web_link"
              >
                {{ notification.data.button_text }}
              </a>
              <a
                v-else data-dismiss="modal"
                aria-label="Close"
                class="button button--primary"
              >
                {{ notification.data.button_text }}
              </a>
            </div>

            <div v-if="isPopupModal && notification.data.button_text">
              <a
                v-if="notification.data.button_web_link"
                @click.prevent="callPost"
                class="button button--primary" href="#"
              >
                {{ notification.data.button_text }}
              </a>
              <a
                v-else
                data-dismiss="modal"
                aria-label="Close"
                class="button button"
              >
                {{ notification.data.button_text }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationModal',
  props: {
    value: {
      required: true
    },
    isBaseModal: Boolean,
    isPopupModal: Boolean,
    notification: Object,
  },
  data() {
    return {};
  },
  watch: {
    value(val) {
      if (val) {
        this.open();
      }
    },
  },
  methods: {
    open() {
      $(this.$refs.notificationModal).modal('show');
    },
    close() {
      this.$emit('input', false);
      this.$emit('close', this.notification);
      $(this.$refs.notificationModal).modal('hide');
    },
    callPost() {
      let vm = this;
      axios.post(this.notification.data.button_web_link)
        .then(response => {
          vm.close();
        })
        .catch(error => {
          if (error.response.data.reason) {
            vm.close();
          }
        });
    }
  },
  mounted() {
    let vm = this;
    $(this.$refs.notificationModal).on('hidden.bs.modal', function (e) {
      vm.close();
    });

    // this.$eventHub.$on('NotificationModalOpen', (notification) => {
    //     vm.open = true;
    //
    // });
  }
};
</script>

<style scoped>

</style>
